// Angular
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
// RxJS
import {Subject} from 'rxjs';
// Translate
import {AuthService} from '../../../../core/ngrx/main/auth.service';

// Auth

@Component({
	selector: 'kt-forgot-password',
	templateUrl: './forgot-password.component.html',
	encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
	// Public params
	forgotPasswordForm: FormGroup;
	loading = false;
	demandeRetour: any = {};
	afficherForm: boolean = true;

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/


	constructor(
		private authService: AuthService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		let pin: string = this.route.snapshot.queryParams.p;
		if (pin) {
			if (pin != '' && pin.length == 6) {
				this.loading = true;
				this.afficherForm= false;
				this.authService.nouveaumotdepasse(pin).subscribe(
					(data: string) => {
						if (data) {
							if (data == '1') {
								this.demandeRetour.ok = true;
								this.demandeRetour.message = 'Votre mot de passe a été reinitialisé. Veuillez consulter votre email pour récupérer votre nouveau mot de passe.';
							} else {
								this.demandeRetour.message = 'Erreur : Votre demande n\'a pas été traitée. Veuillez contacter le support technique';
							}

							this.loading = false;
							this.cdr.detectChanges();
						}
					}
				);
			}
		}

		if(this.afficherForm) {
			this.initRegistrationForm();
		}


	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			]
		});
	}

	/**
	 * Form Submit
	 */
	demanderChangementMotDePasse() {
		let username = this.forgotPasswordForm.controls['email'].value;
		this.loading = true;
		this.demandeRetour = {};
		this.authService.motdepasseoublie(username).subscribe(
			(data: string) => {
				if (data) {
					if (data == '1') {
						this.demandeRetour.ok = true;
						this.demandeRetour.message = 'Votre demande est bien traité. Veuillez consulter votre email pour procéder au changement de mot de passe.';
					} else {
						this.demandeRetour.message = 'Erreur : Votre demande n\'est pas été traité. Veuillez contacter le support technique';
					}

					this.loading = false;
					this.cdr.detectChanges();
				}
			}
		);
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}
}
